import {
  IMeteringAttestationContract,
  IMeteringAttestationRequest,
  IPropertyBblBinRequest,
  IPropertyContract,
  IServiceAttestationAnswer,
  IUnassignedMeterContract,
} from "../contracts/Property";
import {
  deleteDataAsync,
  getDataAsync,
  postDataAsync,
  putDataAsync,
} from "../ZeosApiExecutor";
import { IPropertyCollection } from "./interfaces/IProperty";

let propertyPrefix = "/Property/";

export const Property: IPropertyCollection = {
  getProperty: async (propertyId: number) => {
    const response = await getDataAsync<IPropertyContract>(
      `${propertyPrefix}${propertyId}`,
      "property"
    );
    return response;
  },
  getAllProperties: async (propertyIds: number[]) => {
    const response = await postDataAsync<IPropertyContract[]>(
      `${propertyPrefix}list`,
      propertyIds
    );
    return response;
  },
  postProperty: async (data: IPropertyContract) => {
    const response = await postDataAsync<IPropertyContract>(
      `${propertyPrefix}create`,
      data
    );
    return response;
  },
  postPropertiesBatchAsync: async (data: IPropertyContract[]) => {
    const response = await postDataAsync<IPropertyContract[]>(
      `${propertyPrefix}create-batch`,
      data
    );
    return response;
  },
  putProperty: async (data: IPropertyContract) => {
    const response = await putDataAsync<IPropertyContract>(
      `${propertyPrefix}update`,
      data
    );
    return response;
  },
  updateBblBin: async (propertyId: number, bbl?: string, bin?: string) => {
    const data: IPropertyBblBinRequest = { propertyId, bbl, bin };
    const response = await putDataAsync<IPropertyContract>(
      `${propertyPrefix}update/bbl-bin`,
      data
    );
    return response;
  },
  cloneToSandboxAsync: async (propertyId: number) => {
    const response = await postDataAsync<IPropertyContract>(
      `${propertyPrefix}${propertyId}/clone-sandbox`,
      {}
    );
    return response;
  },
  resetToBaselineAsync: async (propertyId: number) => {
    const response = await postDataAsync<IPropertyContract>(
      `${propertyPrefix}${propertyId}/reset-baseline`,
      {}
    );
    return response;
  },
  deleteSandboxAsync: async (propertyId: number) => {
    const response = await deleteDataAsync<boolean>(
      `${propertyPrefix}${propertyId}/sandbox`,
      {}
    );
    return response;
  },
  propertiesByCompanyId: async (companyId: number) => {
    const response = await getDataAsync<IPropertyContract[]>(
      `${propertyPrefix}company/${companyId}`,
      "Properties"
    );
    return response;
  },
  meteringAttestationPendingAsync: async () => {
    const response = await getDataAsync<IMeteringAttestationContract[]>(
      `${propertyPrefix}metering-attestation/pending`,
      ""
    );
    return response;
  },
  submitMeteringAttestationAsync: async (
    propertyId: number,
    services: IServiceAttestationAnswer[]
  ) => {
    const data: IMeteringAttestationRequest = { services };
    const response = await postDataAsync<IMeteringAttestationContract>(
      `${propertyPrefix}${propertyId}/metering-attestation`,
      data
    );
    return response;
  },
  meteringAttestationStewardQueueAsync: async () => {
    const response = await getDataAsync<IMeteringAttestationContract[]>(
      `${propertyPrefix}metering-attestation/steward-queue`,
      ""
    );
    return response;
  },
  meteringAttestationUnassignedMetersAsync: async () => {
    const response = await getDataAsync<IUnassignedMeterContract[]>(
      `${propertyPrefix}metering-attestation/unassigned-meters`,
      ""
    );
    return response;
  },
};
